import { signal } from "@preact/signals-react"

import { DATE_METRICS } from "@constants"

export const metric = signal(DATE_METRICS.DAILY)